export default __webpack_public_path__ + "static/media/29__tag_microwave.dca1b8fb.svg";